import { render, staticRenderFns } from "./ProcessEditor.vue?vue&type=template&id=d1006d7a&scoped=true&"
import script from "./ProcessEditor.vue?vue&type=script&lang=js&"
export * from "./ProcessEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProcessEditor.vue?vue&type=style&index=0&id=d1006d7a&prod&lang=css&"
import style1 from "./ProcessEditor.vue?vue&type=style&index=1&id=d1006d7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1006d7a",
  null
  
)

export default component.exports